/**
 * Salty Cells — Shared Site JS
 * Handles: mobile nav, FAQ accordion, active nav link, smooth scroll
 */

document.addEventListener('DOMContentLoaded', () => {

  /* -------------------------------------------------------
     NAV SEARCH TOGGLE
  ------------------------------------------------------- */
  const searchWrap  = document.getElementById('nav-search-wrap');
  const searchBtn   = document.getElementById('nav-search-btn');
  const searchForm  = document.getElementById('nav-search-form');
  const searchInput = document.getElementById('nav-search-input');

  if (searchWrap && searchBtn && searchForm) {
    searchBtn.addEventListener('click', () => {
      const isOpen = searchWrap.classList.toggle('open');
      if (isOpen && searchInput) {
        searchInput.focus();
      }
    });

    // Submit on Enter / form submit
    searchForm.addEventListener('submit', e => {
      const q = searchInput ? searchInput.value.trim() : '';
      if (!q) { e.preventDefault(); return; }
      // Allow default form submission (GET /search?q=...)
    });

    // Close on Escape
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && searchWrap.classList.contains('open')) {
        searchWrap.classList.remove('open');
      }
    });

    // Close when clicking outside
    document.addEventListener('click', e => {
      if (!searchWrap.contains(e.target)) {
        searchWrap.classList.remove('open');
      }
    });
  }

  /* -------------------------------------------------------
     MOBILE NAV TOGGLE
  ------------------------------------------------------- */
  const toggle = document.getElementById('nav-toggle');
  const links  = document.getElementById('nav-links');

  if (toggle && links) {
    toggle.addEventListener('click', () => {
      const open = links.classList.toggle('open');
      toggle.classList.toggle('open', open);
      toggle.setAttribute('aria-expanded', open);
    });

    // Close on link click
    links.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        links.classList.remove('open');
        toggle.classList.remove('open');
        toggle.setAttribute('aria-expanded', false);
      });
    });

    // Close on outside click
    document.addEventListener('click', e => {
      if (!toggle.contains(e.target) && !links.contains(e.target)) {
        links.classList.remove('open');
        toggle.classList.remove('open');
      }
    });
  }

  /* -------------------------------------------------------
     ACTIVE NAV LINK
  ------------------------------------------------------- */
  const cp = (window.location.pathname.replace(/\/$/, '')) || '/';
  document.querySelectorAll('.nav__links a').forEach(a => {
    const h = (a.getAttribute('href') || '').replace(/\/$/, '') || '/';
    if (h === cp || (h !== '/' && cp.indexOf(h + '/') === 0)) a.classList.add('active');
  });

  /* -------------------------------------------------------
     FAQ ACCORDION
  ------------------------------------------------------- */
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');

      // Close all
      document.querySelectorAll('.faq-item.open').forEach(openItem => {
        openItem.classList.remove('open');
        openItem.querySelector('.faq-question').setAttribute('aria-expanded', false);
      });

      // Open clicked (unless it was already open)
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', true);
      }
    });
  });

  /* -------------------------------------------------------
     SMOOTH ANCHOR SCROLL
  ------------------------------------------------------- */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const navHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-height'), 10) || 72;
        const top = target.getBoundingClientRect().top + window.scrollY - navHeight - 16;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  /* -------------------------------------------------------
     CONTACT FORM — Client-side validation
  ------------------------------------------------------- */
  const contactForm = document.getElementById('contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', e => {
      const name    = document.getElementById('contact-name');
      const email   = document.getElementById('contact-email');
      const message = document.getElementById('contact-message');
      let valid = true;

      [name, email, message].forEach(field => {
        field.style.borderColor = '';
        const label = field.closest('.form-group')?.querySelector('.form-error');
        if (label) label.remove();
      });

      if (!name.value.trim()) {
        showError(name, 'Please enter your name');
        valid = false;
      }
      if (!email.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
        showError(email, 'Please enter a valid email address');
        valid = false;
      }
      if (!message.value.trim() || message.value.trim().length < 10) {
        showError(message, 'Please enter a message (min 10 characters)');
        valid = false;
      }

      if (!valid) e.preventDefault();
    });
  }

  function showError(field, msg) {
    field.style.borderColor = 'var(--error)';
    const err = document.createElement('p');
    err.className = 'form-error text-xs';
    err.style.color = 'var(--error)';
    err.style.marginTop = '0.35rem';
    err.textContent = msg;
    field.closest('.form-group').appendChild(err);
  }

  /* -------------------------------------------------------
     SCROLL REVEAL — lightweight animation
  ------------------------------------------------------- */
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.reveal').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
    revealObserver.observe(el);
  });

  // Add revealed state
  const style = document.createElement('style');
  style.textContent = '.revealed { opacity: 1 !important; transform: none !important; }';
  document.head.appendChild(style);

});
